const platforms = [
  { label: 'Cloudcart', value: 'cloudcart' },
  { label: 'Magento 1.x', value: 'magento1' },
  { label: 'Magento 2.x', value: 'magento2' },
  { label: 'OpenCart', value: 'opencart' },
  { label: 'Shopify', value: 'shopify' },
  { label: 'WordPress / WooCommerce', value: 'woocommerce' },
  { label: 'CS-Cart', value: 'cscart' },
  { label: 'MerchantPro', value: 'merchantpro' },
  { label: 'GombaShop', value: 'gombashop' },
  { label: 'Shopiko', value: 'shopiko' },
  { label: 'PrestaShop', value: 'prestashop' },
  { label: 'Valival', value: 'valival' },
  { label: 'Gomag', value: 'gomag' },
  { label: 'XXSale', value: 'xxsale' },
  { label: 'Other / Custom', value: 'custom' },
];

export default platforms;
